// src\themes\tolica\components\VideoBannerWidget.tsx
"use client"

import FileUploadInput from "@/components/account/input/MultipleFileUploadInput";
import TextInput from "@/components/account/input/TextInput";
import { MultilingualInput } from "@/components/account/widgets/GlobalWidgetEditor";

import { useDictionary } from "@/core/hooks/use-dictionary";
import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";


interface VideoBannerWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

export const VideoBannerWidget = ({
    widgetIndex,
    name,
    control,
    register,
    errors,
    disabled,
}: VideoBannerWidgetProps) => {
    const { dictionary } = useDictionary();

    const getError = (path: string) => {
        const errorPath = path.split('.');
        let current = errors;
        for (const key of errorPath) {
            if (current && typeof key === 'string' && key in current) {
                current = (current as any)[key];
            } else {
                return undefined;
            }
        }
        return (current as any)?.message;
    };

    const imageError = getError(`${name}.${widgetIndex}.image`) as string | undefined;

    return (
        <div className="space-y-4">
            <Controller
                control={control}
                name={`${name}.${widgetIndex}.image`}
                render={({ field }) => (
                    <FileUploadInput
                        accept="image/*,video/*"
                        disabled={disabled}
                        onUploadSuccess={(image) => {
                            if (!Array.isArray(image) && image) field.onChange(image);
                        }}
                        defaultImages={
                            field.value
                                ? [
                                    {
                                        ...field.value,
                                        name: field.value.name || '',
                                        description: field.value.description || '',
                                    },
                                ]
                                : []
                        }
                        onDefaultRemove={() => field.onChange(undefined)}
                        error={imageError}
                    />
                )}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.title`}
                label={dictionary.forms?.title}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.buttonContent`}
                label={dictionary.forms?.buttonContent}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <TextInput
                name={`${name}.${widgetIndex}.link`}
                label={dictionary.forms?.link}
                placeholder={dictionary.forms?.link}
                register={register}
                errors={errors}
                disabled={disabled}
            />
        </div>
    );
};






// api دراپ داون لیست شعب /api/admin/shop-marketplace/list



// رسپانسش

// {

//   "status": "success",

//   "message": "messages.success_fetch_items",

//   "data": [

//     {

//       "value": 26,

//       "label": "ارم",

//       "owner_id": 5994

//     },

//     {

//       "value": 21,

//       "label": "اروژ",

//       "owner_id": 11279

//     },

//     {

//       "value": 20,

//       "label": "تولیکا",

//       "owner_id": 5819

//     },

//     {

//       "value": 19,

//       "label": "چوپر",

//       "owner_id": 11279

//     },

//     {

//       "value": 30,

//       "label": "دیجیکالا",

//       "owner_id": 11236

//     },

//     {

//       "value": 31,

//       "label": "شمشک",

//       "owner_id": 11279

//     },

//     {

//       "value": 22,

//       "label": "ونداهوم",

//       "owner_id": 7248

//     }

//   ]

// }







// api لیست شعب های فروشگاه /api/admin/shop-marketplace

// رسپانسش
// {
//   "status": "success",
//   "message": "موفق در استخراج اطلاعات",
//   "data": {
//     "current_page": 1,
//     "data": [
//       {
//         "id": 19,
//         "owner_id": 11279,
//         "title": "چوپر",
//         "title_en": null,
//         "title_ar": null,
//         "address": "مشهد",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09039318332",
//         "thumbnail": 4,
//         "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2019/01/jpg/27bb0661447cc8b033c8101fbb2dddad.jpg",
//         "lat": "90.0000000",
//         "lon": "60.0000000",
//         "created_at": "2026-07-16 12:13:28",
//         "updated_at": "2026-07-16 12:13:28",
//         "created_at_jalali": "1405/04/25 12:13:28",
//         "updated_at_jalali": "1405/04/25 12:13:28"
//       },
//       {
//         "id": 20,
//         "owner_id": 5819,
//         "title": "تولیکا",
//         "title_en": null,
//         "title_ar": null,
//         "address": "تهران",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09039318332",
//         "thumbnail": 7,
//         "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2019/01/jpg/0f5a8449bbec60d439caa6e03958098b.jpg",
//         "lat": "6.0000000",
//         "lon": "5.0000000",
//         "created_at": "2026-07-16 12:20:39",
//         "updated_at": "2026-07-16 12:20:39",
//         "created_at_jalali": "1405/04/25 12:20:39",
//         "updated_at_jalali": "1405/04/25 12:20:39"
//       },
//       {
//         "id": 21,
//         "owner_id": 11279,
//         "title": "اروژ",
//         "title_en": null,
//         "title_ar": null,
//         "address": "مشهد",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09039318332",
//         "thumbnail": 8,
//         "thumbnail_url": null,
//         "lat": "90.0000000",
//         "lon": "180.0000000",
//         "created_at": "2026-07-16 12:30:38",
//         "updated_at": "2026-07-16 12:30:38",
//         "created_at_jalali": "1405/04/25 12:30:38",
//         "updated_at_jalali": "1405/04/25 12:30:38"
//       },
//       {
//         "id": 22,
//         "owner_id": 7248,
//         "title": "ونداهوم",
//         "title_en": null,
//         "title_ar": null,
//         "address": "تهران",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09380034175",
//         "thumbnail": 9,
//         "thumbnail_url": null,
//         "lat": "30.0000000",
//         "lon": "50.0000000",
//         "created_at": "2026-07-16 12:47:34",
//         "updated_at": "2026-07-16 12:47:34",
//         "created_at_jalali": "1405/04/25 12:47:34",
//         "updated_at_jalali": "1405/04/25 12:47:34"
//       },
//       {
//         "id": 26,
//         "owner_id": 5994,
//         "title": "ارم",
//         "title_en": null,
//         "title_ar": null,
//         "address": "مشهد",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "09039318332",
//         "mobile": "09039318332",
//         "thumbnail": 6,
//         "thumbnail_url": null,
//         "lat": "89.0000000",
//         "lon": "8.0000000",
//         "created_at": "2026-07-16 15:13:20",
//         "updated_at": "2026-07-16 15:13:20",
//         "created_at_jalali": "1405/04/25 15:13:20",
//         "updated_at_jalali": "1405/04/25 15:13:20"
//       },
//       {
//         "id": 30,
//         "owner_id": 11236,
//         "title": "دیجیکالا",
//         "title_en": null,
//         "title_ar": null,
//         "address": "مشهد پیامبراعظم",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09039318332",
//         "thumbnail": 43763,
//         "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2026/07/48651a42-80ed-47b4-a144-2c8f25779299-6a5e0aa78f0ab.png",
//         "lat": "35.9985500",
//         "lon": "51.3890000",
//         "created_at": "2026-07-20 15:17:09",
//         "updated_at": "2026-07-20 15:17:09",
//         "created_at_jalali": "1405/04/29 15:17:09",
//         "updated_at_jalali": "1405/04/29 15:17:09"
//       },
//       {
//         "id": 31,
//         "owner_id": 11279,
//         "title": "شمشک",
//         "title_en": null,
//         "title_ar": null,
//         "address": "مشهد",
//         "address_en": null,
//         "address_ar": null,
//         "phone": "05132566688",
//         "mobile": "09380034175",
//         "thumbnail": 43765,
//         "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2026/07/9c016424-a914-4e21-a8be-5a1d8d23903e-6a5f30c68c436.png",
//         "lat": "35.9985500",
//         "lon": "51.3890000",
//         "created_at": "2026-07-21 12:11:59",
//         "updated_at": "2026-07-21 12:11:59",
//         "created_at_jalali": "1405/04/30 12:11:59",
//         "updated_at_jalali": "1405/04/30 12:11:59"
//       }
//     ],
//     "first_page_url": "http://tolicasrv.xoos.ir/api/admin/shop-marketplace?page=1",
//     "from": 1,
//     "last_page": 1,
//     "last_page_url": "http://tolicasrv.xoos.ir/api/admin/shop-marketplace?page=1",
//     "links": [
//       {
//         "url": null,
//         "label": "&laquo; قبلی",
//         "active": false
//       },
//       {
//         "url": "http://tolicasrv.xoos.ir/api/admin/shop-marketplace?page=1",
//         "label": "1",
//         "active": true
//       },
//       {
//         "url": null,
//         "label": "بعدی &raquo;",
//         "active": false
//       }
//     ],
//     "next_page_url": null,
//     "path": "http://tolicasrv.xoos.ir/api/admin/shop-marketplace",
//     "per_page": 10,
//     "prev_page_url": null,
//     "to": 7,
//     "total": 7
//   }
// }




// api اطلاعات شعبه /api/admin/shop-marketplace/20

// رسپانسش

// {

//   "status": "success",

//   "message": "Data fetched successfully",

//   "data": {

//     "id": 20,

//     "owner_id": 5819,

//     "title": "تولیکا",

//     "title_en": null,

//     "title_ar": null,

//     "address": "تهران",

//     "address_en": null,

//     "address_ar": null,

//     "phone": "05132566688",

//     "mobile": "09039318332",

//     "thumbnail": 7,

//     "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2019/01/jpg/0f5a8449bbec60d439caa6e03958098b.jpg",

//     "lat": "6.0000000",

//     "lon": "5.0000000",

//     "created_at": "2026-07-16 12:20:39",

//     "updated_at": "2026-07-16 12:20:39",

//     "created_at_jalali": "1405/04/25 12:20:39",

//     "updated_at_jalali": "1405/04/25 12:20:39",

//     "owner": {

//       "id": 5819,

//       "name": null,

//       "email": null

//     }

//   }

// }



// api افزودن شعبه /api/admin/shop-marketplace

// ریکوئستش

// {

//   "owner_id": 2,

//   "title": "فروشگاه دیجیکالا - شعبه تهرانپارس",

//   "title_en": "Digikala Store - Tehranpars Branch",

//   "title_ar": "متجر ديجي كالا - فرع طهران بارس",

//   "address": "تهران، تهرانپارس، خیابان جشنواره، پلاک ۱۲۳",

//   "address_en": "Tehran, Tehranpars, Jashnvareh Street, No. 123",

//   "address_ar": "طهران، طهران بارس، شارع جشنواره، رقم ۱۲۳",

//   "phone": "02161930000",

//   "mobile": "09121234567",

//   "thumbnail": 55,

//   "lat": 35.7351947,

//   "lon": 51.5524521

// }

// رسپانسش

// {

//   "status": "success",

//   "message": "Successfully created item",

//   "data": {

//     "id": 33,

//     "owner_id": 2,

//     "title": "فروشگاه دیجیکالا - شعبه تهرانپارس",

//     "title_en": "Digikala Store - Tehranpars Branch",

//     "title_ar": "متجر ديجي كالا - فرع طهران بارس",

//     "address": "تهران، تهرانپارس، خیابان جشنواره، پلاک ۱۲۳",

//     "address_en": "Tehran, Tehranpars, Jashnvareh Street, No. 123",

//     "address_ar": "طهران، طهران بارس، شارع جشنواره، رقم ۱۲۳",

//     "phone": "02161930000",

//     "mobile": "09121234567",

//     "thumbnail": 55,

//     "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2019/01/jpg/aa30799b62f8820f1edcb242b53ef7fe.jpg",

//     "lat": "35.7351947",

//     "lon": "51.5524521",

//     "created_at": "2026-08-10 15:13:47",

//     "updated_at": "2026-08-10 15:13:47",

//     "created_at_jalali": "1405/05/19 15:13:47",

//     "updated_at_jalali": "1405/05/19 15:13:47",

//     "owner": {

//       "id": 2,

//       "name": null,

//       "email": "support@tolica.ir"

//     }

//   }

// }



// api ویرایش و بروزرسانی شعبه /api/admin/shop-marketplace/20

// ریکوئستش

// {

//   "owner_id": 1,

//   "title": "فروشگاه دیجیکالا - شعبه تهرانپارس",

//   "title_en": "Digikala Store - Tehranpars Branch",

//   "title_ar": "متجر ديجي كالا - فرع طهران بارس",

//   "address": "تهران، تهرانپارس، خیابان جشنواره، پلاک ۱۲۳",

//   "address_en": "Tehran, Tehranpars, Jashnvareh Street, No. 123",

//   "address_ar": "طهران، طهران بارس، شارع جشنواره، رقم ۱۲۳",

//   "phone": "02161930000",

//   "mobile": "09121234567",

//   "thumbnail": 45,

//   "lat": 35.7351947,

//   "lon": 51.5524521

// }



// رسپانسش

// {

//   "status": "success",

//   "message": "Successfully Created Item",

//   "data": {

//     "id": 20,

//     "owner_id": 1,

//     "title": "فروشگاه دیجیکالا - شعبه تهرانپارس",

//     "title_en": "Digikala Store - Tehranpars Branch",

//     "title_ar": "متجر ديجي كالا - فرع طهران بارس",

//     "address": "تهران، تهرانپارس، خیابان جشنواره، پلاک ۱۲۳",

//     "address_en": "Tehran, Tehranpars, Jashnvareh Street, No. 123",

//     "address_ar": "طهران، طهران بارس، شارع جشنواره، رقم ۱۲۳",

//     "phone": "02161930000",

//     "mobile": "09121234567",

//     "thumbnail": 45,

//     "thumbnail_url": "https://tolicasrv.xoos.ir/public/attachments/2019/01/jpg/7fdb8fc6b85def54b8e02129f59e7f4f.jpg",

//     "lat": "35.7351947",

//     "lon": "51.5524521",

//     "created_at": "2026-07-16 12:20:39",

//     "updated_at": "2026-08-10 15:15:28",

//     "created_at_jalali": "1405/04/25 12:20:39",

//     "updated_at_jalali": "1405/05/19 15:15:28",

//     "owner": {

//       "id": 1,

//       "name": null,

//       "email": "email@email.com"

//     }

//   }

// }



// api حذف تکی یا دسته جمعی /api/admin/shop-marketplace/delete-multiple

// ریکوئستش

// {

//   "ids": [ 10,11]

// }

// رسپانسش

// {

//   "status": "success",

//   "message": "موفق در حذف آیتم",

//   "data": {

//     "deleted_ids": [],

//     "blocked_relations": []

//   }

// }



// api لیست یوزر ها /api/admin/users/list

// رسپانسش

// {
//   "status": true,
//   "message": "Data fetched successfully",
//   "data": [
//     {
//       "label": "  - Customer Code: 11779 - Mobile: 09046724100",
//       "value": 11779
//     },
//     {
//       "label": "  - Customer Code: 11780 - Mobile: 09204051382",
//       "value": 11780
//     },
//     {
//       "label": "  - Customer Code: 11781 - Mobile: 09301674906",
//       "value": 11781
//     },
//      {
//       "label": "یونس نمازی - Customer Code: 9753 - Mobile: 09195436327",
//       "value": 9753
//     }
//   ]
// }